import React from "react"
import PropTypes from "prop-types"
import Spinner from "components/common/Spinner"
import ZoomButtons from "components/map/ZoomButtons"
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api"
import { API_OPTIONS, DEFAULT_ZOOM, MAP_OPTIONS, MARKER_ICON } from "constants/map"
import { useLocation } from "react-router-dom"

Location.propTypes = {
  height: PropTypes.number,
  centerLatLng: PropTypes.object,
  meetingLatLng: PropTypes.string,
  onMarkerDragEnd: PropTypes.func
}

export default function Location({ height = 330, centerLatLng, meetingLatLng, onMarkerDragEnd }) {
  const { isLoaded } = useJsApiLoader(API_OPTIONS)
  const zoom = DEFAULT_ZOOM
  const location = useLocation()

  const isPreviewMode = location.pathname.includes("preview") && location.search.includes("readOnlyPreview=true")

  const handleMarkerDragEnd = (event) => {
    if (isPreviewMode) return

    const newLat = event.latLng.lat()
    const newLng = event.latLng.lng()
    
    if (onMarkerDragEnd) {
      onMarkerDragEnd({ lat: newLat, lng: newLng })
    }
  }
  
  return isLoaded ? (
    <GoogleMap
      mapContainerClassName="rounded"
      mapContainerStyle={{ height }}
      options={{ ...MAP_OPTIONS, draggable: !isPreviewMode }}
      center={centerLatLng}
      zoom={zoom}
    >
      {centerLatLng && meetingLatLng && (
        <Marker 
          position={centerLatLng}
          // eslint-disable-next-line no-undef
          icon={{ ...MARKER_ICON, scaledSize: new globalThis.google.maps.Size(30, 30) }}
          draggable={!isPreviewMode}
          onDragEnd={handleMarkerDragEnd}
        />
      )}
      <div className="vstack position-absolute p-10 w-100 h-100 gap-10 pointer-events-none">
        <ZoomButtons />
      </div>
    </GoogleMap>
  ) : (
    <div className="hstack bg-white p-50 rounded" style={{ height: 330 }}>
      <Spinner className="m-auto" />
    </div>
  )
}
